import { Component } from '@angular/core';

import { FieldBaseComponent } from '../base-component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-lib-ff-custom-radio',
  styleUrls: ['custom-radio.component.scss'],
  templateUrl: 'custom-radio.component.html',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    FormlyModule,
    NgClass,
  ],
})
export class FormlyCustomRadioListComponent extends FieldBaseComponent {
  public optionsList(): any[] {
    const options = this.props?.options;
    return Array.isArray(options) ? options : [];
  }

  public get hasOnlyText() {
    return (this.props.options as any[]).every((x) => x.label && !x.icon);
  }
}
